import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import LogoSlider from "../../components/client/LogoSlider";
import Member from "../../components/client/Members";
import ButtonTitle from "../../components/ButtonTitle";
import ArticleCard from "../../components/client/ArticleCard";
import { useParams } from "react-router-dom";
import { convertToSlug } from "../../utils/helps";
import { Link } from "react-router-dom";
import { HomeIcon } from "@heroicons/react/24/outline";

function News() {
  const posts = useSelector((state) =>
    state.posts?.posts?.filter(
      (post) =>
        post.status === "published" &&
        post.slug !== "gioi-thieu" &&
        post.slug !== "dieu-khoan"
    )
  )?.filter(
    (post) =>
      post.category?.name !== "Điều khoản" ||
      post.category?.name !== "Giới thiệu"
  );
  const { navbars } = useSelector((state) => state.categories);
  const { slug } = useParams();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const groupPostsByCategory = (posts) => {
    let filteredPosts = posts;

    // Nếu slug undefined, lọc các bài viết có category nằm trong navbars
    if (!slug) {
      const navbarCategories = new Set(navbars.map((item) => item.name));
      filteredPosts = posts.filter(
        (post) => !navbarCategories.has(post?.category?.name)
      );
    }

    return filteredPosts.reduce((acc, post) => {
      const categoryName = post?.category?.name || "Chưa phân loại";
      if (!acc[categoryName]) {
        acc[categoryName] = [];
      }
      acc[categoryName].push(post);
      return acc;
    }, {});
  };

  const groupedPosts = groupPostsByCategory(posts);

  const displayedCategories = slug
    ? Object.keys(groupedPosts).filter(
        (categoryName) => convertToSlug(categoryName) === slug
      )
    : Object.keys(groupedPosts);

  return (
    <div className="container mx-auto">
      <nav className="flex text-gray-500 text-sm mb-4" aria-label="Breadcrumb">
        <ol className="inline-flex items-center space-x-1 md:space-x-2 flex-wrap">
          <li className="inline-flex items-center">
            <Link to="/" className="inline-flex items-center hover:text-blue-600 font-medium">
              <HomeIcon className="w-4 h-4 mr-2 text-gray-400" />
              Trang chủ
            </Link>
          </li>
          <li>
            <div className="flex items-center">
              <svg className="w-3 h-3 mx-2 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                <path d="M7.05 4.05a.75.75 0 011.06 0l5.25 5.25a.75.75 0 010 1.06l-5.25 5.25a.75.75 0 11-1.06-1.06L11.19 10 7.05 5.91a.75.75 0 010-1.06z" />
              </svg>
              <span className="ml-1 text-gray-400 font-medium">Tin tức và sự kiện</span>
            </div>
          </li>
        </ol>
      </nav>

      <div className="grid grid-cols-1 md:grid-cols-12 gap-4 mt-3 mb-2">
        <div className="col-span-12 md:col-span-8">
          {displayedCategories?.length > 0 ? (
            displayedCategories.map((categoryName) => (
              <div key={categoryName}>
                <h2 className="font-bold mb-4">
                  <ButtonTitle title={categoryName} />
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  {groupedPosts[categoryName].map((article) => (
                    <ArticleCard key={article.id} article={article} />
                  ))}
                </div>
              </div>
            ))
          ) : (
            <p className="text-center">Không có bài viết</p>
          )}
        </div>
        <div className="col-span-12 md:col-span-4">
          <div className="sticky top-[80px]">
            <ButtonTitle title="Hội viên BCCU mới" />
            <LogoSlider />
          </div>
        </div>
      </div>

      <ButtonTitle title="Hội viên BCCU" />
      <Member />
    </div>
  );
}

export default News;
